import BaseApi from './baseApi';
import IListTypesOutbounds from '../models/IListTypesOutbounds';
import IAuthentication from '../models/IAuthentication';
export default class ListTypesOutboundsApi extends BaseApi {
    idUser : string = "";
    idCompany : string = "";
    constructor() {
        super("dataaccess", "Settings");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
        this.idCompany = userFromStorage.idCompany;
    }

    async GetListTypesOutbounds() : Promise<IListTypesOutbounds[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var listTypesOutbounds: IListTypesOutbounds[] = [];
            listTypesOutbounds = response.data as IListTypesOutbounds[];
            return listTypesOutbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveListTypesOutbounds(listTypesOutbounds: IListTypesOutbounds) : Promise<string> {
        const json = this.getJsonSave(listTypesOutbounds);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateListTypesOutbounds(listTypesOutbounds: IListTypesOutbounds) : Promise<boolean> {
        const json = this.getJsonUpdate(listTypesOutbounds);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteListTypesOutbounds(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async inUseSetting(id: string) : Promise<boolean> {
        const json = this.getInUseJson(id);
        const response = await this.api.post('ExecWithResults', json);
        if (!response) return false;
        if (response.isSuccess) {
            const data = response.data as any[];
            return Number(data && data[0] && data[0].isInUse) === 1;
        } else {
            this.modelState = response.errorState;
            return false;
        }
    }

    private getInUseJson(id: string) : any {
        const json = {
            "spname": "dbo.IS_TYPES_OUTBOUNDS_IN_USE",
            "parameters": [{
                "Item1": "TypesOutboundsId ",
                "Item2": id
            }, {
                "Item1": "companyId ",
                "Item2": this.idCompany
            }]
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "ListTypesOutbounds",
                "Item2": "id"
            }, {
                "Item1": "ListTypesOutbounds",
                "Item2": "name"
            }, {
                "Item1": "ListTypesOutbounds",
                "Item2": "canDelete"
            }],
            "tables": [{
                "Item1": "ListTypesOutbounds"
            }],
            "conditions": [{
                "Item1": "ListTypesOutbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "ListTypesOutbounds",
                "Item2": "idCompany",
                "Item3": "=",
                "Item4": this.idCompany
            }],
            "orderBy": [{
                "Item1": "ListTypesOutbounds.name"
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "ListTypesOutbounds",
            "conditions": [{
                "Item1": "ListTypesOutbounds",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(listTypesOutbounds: IListTypesOutbounds) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listTypesOutbounds.name
            }, {
                "Item1": "idCompany",
                "Item2": this.idCompany
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CanDelete",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "ListTypesOutbounds"
        };
        return json;
    }

    private getJsonUpdate(listTypesOutbounds: IListTypesOutbounds) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listTypesOutbounds.name
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "ListTypesOutbounds",
            "keyvalue": listTypesOutbounds.id
        };
        return json;
    }
}
